<div class="inbox-general home-section">
    <div class="title-section">
        <div class="inbox-marker"></div>
        <div class="div-label">
            <mat-label class="label-title">General</mat-label>   
            <div class="div-order">
                <mat-label class="label-select">Ordenar por fecha</mat-label>
                <mat-form-field class = "dense-3">
                    <mat-select [(ngModel)]="selectedValue" (selectionChange)="reorderHandovers($event)" name="order-ho">
                        <mat-option *ngFor="let op of optionsOrder" [value]="op.value">
                        {{op.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="search-section">
        <mat-form-field  class="search-well-card dense-3">
            <mat-label class="label-well">Buscá un pozo</mat-label> 
            <input type="text" aria-label="Well" matInput #searchText (keyup.enter)="getHandoversHomeGeneralWithFilter(searchText.value)">
            <span matSuffix class="cursor-pointer" (click)="getHandoversHomeGeneralWithFilter(searchText.value)">
                <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
            </span>
        </mat-form-field>
    </div>
    <div class="content-section">
        <div class="handovers" *ngIf="totalHandoversGeneral != 0">
            <app-handover-card *ngFor="let handover of handoversGeneral" [handover]="handover"
            (reload)="eventReload($event)" [destinationLabel]="destinationLabel"></app-handover-card>
        </div>
        <div class="empty-content" *ngIf="totalHandoversGeneral == 0">
            <div *ngIf="this.textSearch == ''">
                <p class="general-empty">No hay Handovers aún</p>
                <p class="general-empty-text">Aquí podrás visualizar los <br> Handovers recibidos</p>
            </div>          
             <div *ngIf="this.textSearch != ''">
                <p class="general-empty">No hay handovers para el filtro aplicado</p>
            </div>
        </div>
    </div>
</div>